import { render } from "./orderSuccess.vue?vue&type=template&id=d0ad6014&scoped=true"
import script from "./orderSuccess.vue?vue&type=script&lang=js"
export * from "./orderSuccess.vue?vue&type=script&lang=js"

import "./orderSuccess.vue?vue&type=style&index=0&id=d0ad6014&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ad6014"]])

export default __exports__